<app-agreement-ack *ngIf="agreementType === 'ack'"></app-agreement-ack>
<app-agreement-free-idle-warning *ngIf="agreementType === 'free-idle-warning'"></app-agreement-free-idle-warning>
